import * as React from 'react';
import style from './solution-details.scss';
import { composer } from '../../../../../component-decorators/composer';
import { Text, Box } from '@wix/design-system';
export const SolutionDetails = composer()
    .withTranslation()
    .compose(({ teaser, name, isWixOffering, t, companyName, }) => {
    const subtitle = !teaser && isWixOffering
        ? t('solutionBox.wixOffering.description')
        : teaser;
    return (React.createElement("div", { className: style.solutionDetail },
        React.createElement(Box, { className: style.titleCompany, direction: "vertical" },
            React.createElement(Text, { weight: "bold" }, name)),
        React.createElement(Box, { maxWidth: "260px", marginTop: "6px" },
            React.createElement(Text, { dataHook: "solution-teaser", size: "small", weight: "thin", className: style.solutionTeaser }, subtitle))));
});
//# sourceMappingURL=index.js.map